import type { MultiMeterBarChartTooltipVariant } from './types/multi-meter-bar-chart.js';
import type { ColorPalette } from '../../core/types/color-palette.js';
import {
  SIZE_DEFAULT,
  MIN_DEFAULT_VALUE,
  MAX_DEFAULT_VALUE,
  DEFAULT_FORMATTER,
} from '../shared/constants.js';

export const DEFAULT_COLOR_PALETTE: ColorPalette = 'categorical';
const TOOLTIP_VARIANT_DEFAULT: MultiMeterBarChartTooltipVariant = 'single';

export const defaultConfig = {
  colorPalette: DEFAULT_COLOR_PALETTE,
  size: SIZE_DEFAULT,
  min: MIN_DEFAULT_VALUE,
  max: MAX_DEFAULT_VALUE,
  tooltip: { hidden: false, variant: TOOLTIP_VARIANT_DEFAULT },
  formatter: DEFAULT_FORMATTER,
  legend: false,
  loading: false,
};
